import api from './api'
import { IScanStatusResponse } from 'models/scan.model'

const getCompanyScanStatus = async (companyId): Promise<IScanStatusResponse> => {
  const { data } = await api.get<IScanStatusResponse>(`/v2/company/${companyId}/scan/status`)
  return data
}
export default {
  getCompanyScanStatus,
}
